import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Ciudad } from 'src/app/comun/models/ciudad';
import { Departamento } from 'src/app/comun/models/departamento';
import { ParametrosService } from 'src/app/services/parametros.service';
import { NeoCiudadClienteDTO } from '../../Model/neoCiudadClienteDTO';
import { NeoDepartamentosClienteDTO } from '../../Model/neoDepartamentosClienteDTO';
import { CiudadClienteService } from '../../Service/ciudad-cliente.service';
import { DepartamentosClienteService } from '../../Service/departamentos-cliente.service';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';

declare var $: any;
@Component({
    selector: 'app-editar-ubicaciones-intermediario',
    templateUrl: './editar-ubicaciones-intermediario.component.html',
    styleUrls: ['./editar-ubicaciones-intermediario.component.scss'],
    standalone: false
})
export class EditarUbicacionesIntermediarioComponent implements OnInit {
  //idDepartamentoCliente
  idDepartamentoCliente: any;
  //idCiudadCliente
  idCiudadCliente: any;
  //objeto departamento a editar
  departamentoCliente: NeoDepartamentosClienteDTO;
  //Lista de departamentos
  departamentos: Departamento[] = [];
  //objeto ciudad a editar
  ciudadCliente: NeoCiudadClienteDTO;
  //Lista de ciudades
  ciudades: Ciudad[] = [];
  //Formulario lugares de atencion
  lugaresAtencionForm: UntypedFormGroup;
  constructor(
    protected parametroService: ParametrosService,
    protected departamentosClienteService: DepartamentosClienteService,
    protected ciudadClienteService: CiudadClienteService,
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    private activatedRoute: ActivatedRoute,
    private _sweetAlert: SweetAlertService
  ) { }

  ngOnInit(): void {
    this.idDepartamentoCliente = this.activatedRoute.snapshot.paramMap.get('idDepartamento');
    this.getDepartamentos('169');
    this.crearFormularioLugaresAtencion();
  }

  getDepartamentos(idPais: string) {
    this.parametroService.getDepartamentos(idPais).subscribe(
      (response) => {
        this.departamentos = response['data'];
        this.getDepartamentoCliente();
      },
      (err) => {
        console.error(err);
      },
      () => {
        setTimeout(() => {
          $('#ciud').prop('disabled', true);
          $('.selectpicker').selectpicker('refresh');
        });
      }
    );
  }

  getCiudades(idDepartamento: string) {
    this.parametroService.getCiudades(idDepartamento).subscribe(
      (response) => {
        this.ciudades = response['data'];
      },
      (err) => {
        console.error(err);
      },
      () => {
        setTimeout(() => {
          $('#ciud').prop('disabled', false);
          $('#ciud').selectpicker('refresh');
        });
      }
    );
  }
  crearFormularioLugaresAtencion() {
    this.lugaresAtencionForm = this.formBuilder.group({
      idDepartamentoCliente: [''],
      idDepartamento: ['', Validators.required],
      idCliente_NeoCliente: [''],
      aplicaTodasCiudades: [''],
      estado: [''],
      ciudades: [''],
    });
  }

  getDepartamentoCliente() {
    if (this.idDepartamentoCliente !== 'null') {
      this.departamentosClienteService
        .getDepartamentosClientePorId(this.idDepartamentoCliente)
        .subscribe(
          (data: any) => {
            this.departamentoCliente = data;
            this.lugaresAtencionForm.controls.idDepartamentoCliente.patchValue(
              this.departamentoCliente.idDepartamentoCliente
            );
            this.lugaresAtencionForm.controls.idDepartamento.patchValue(
              this.departamentoCliente.idDepartamento
            );
            if (this.departamentoCliente.aplicaTodasCiudades === 1) {
              this.lugaresAtencionForm.controls.aplicaTodasCiudades.patchValue(true);
            } else {
              this.lugaresAtencionForm.controls.aplicaTodasCiudades.patchValue(false);
            }
            this.lugaresAtencionForm.controls.idCliente_NeoCliente.patchValue(this.departamentoCliente.idCliente_NeoCliente);
            this.lugaresAtencionForm.controls.estado.patchValue(
              this.departamentoCliente.estado
            );
            this.getCiudades(
              this.departamentoCliente.idDepartamento.toString()
            );
            this.lugaresAtencionForm.controls.ciudades.patchValue(
              this.obtenerIdCiudad(this.departamentoCliente.ciudades)
            );
            setTimeout(() => {
              $('#dept').prop('disabled', true);
              $('.selectpicker').selectpicker('refresh');
              $('#ciud').selectpicker('refresh');
            });
          },
          (err) => {
            console.error(err);
          }
        );
    }
  }

  obtenerIdCiudad(lista: NeoCiudadClienteDTO[]) {
    let idCiudades: any[] = []
    lista.forEach((element: any) => {
      idCiudades.push(element.idCiudad);
    });
    return idCiudades;
  }

  modificarLugar() {
    let auxTodasCiudades = this.lugaresAtencionForm.get('aplicaTodasCiudades').value
    let json: NeoDepartamentosClienteDTO = {
      idDepartamentoCliente: +this.lugaresAtencionForm.get('idDepartamentoCliente').value,
      idDepartamento: +this.lugaresAtencionForm.get('idDepartamento').value,
      idCliente_NeoCliente: this.lugaresAtencionForm.get('idCliente_NeoCliente').value,
      aplicaTodasCiudades: auxTodasCiudades == true ? 1 : 0,
      estado: this.lugaresAtencionForm.get('estado').value,
      ciudades: this.guardarCiudadesEditar()
    }
    if (auxTodasCiudades) {
      json.ciudades = [];
    }
    this.departamentosClienteService
      .updateDepartamentosCliente(json)
      .subscribe(
        (resp: any) => {
          if (resp.exitoso) {
            this.navegarMenuInicialUbicaciones();
            this._sweetAlert.successModal('Se ha modificado el lugar de atención');
          } else {
            this._sweetAlert.errorModal('Se presento un error al momento de modificar el lugar de atención');
          }
        },
        (err) => {
          console.error(err);
        }
      );
  }

  guardarCiudadesEditar() {
    let arregloCiudades: NeoCiudadClienteDTO[] = [];
    if (this.lugaresAtencionForm.controls.ciudades.value) {
      let valoresCiudades: any[] =
        this.lugaresAtencionForm.controls.ciudades.value;
      valoresCiudades.forEach((idC) => {
        const ciudadSegmento: NeoCiudadClienteDTO = {
          idCiudad: idC,
          idDepartamentoCliente_NeoDepartamentosCliente: +this.lugaresAtencionForm.get('idDepartamentoCliente').value,
          idCiudadCliente: null,
          estado: 'HABILITADO',
        };
        arregloCiudades.push(ciudadSegmento);
      });
      return arregloCiudades;
    } else {
      return arregloCiudades = [];
    }
  }

  navegarMenuInicialUbicaciones() {
    this.router.navigate(['/intermediario/administracion/ubicaciones']);
  }

  validarCiudades(event: any) {
    const checkbox = event.target as HTMLInputElement;
    const isChecked = checkbox.checked;
    if (isChecked) {
      this.lugaresAtencionForm.get('ciudades').setValue(null);
      $('#ciud').selectpicker('refresh');
      this.lugaresAtencionForm.controls.ciudades.clearValidators();
    } else {
      this.lugaresAtencionForm.controls.ciudades.setValidators([Validators.required]);
    }
    this.lugaresAtencionForm.controls.ciudades.updateValueAndValidity();
  }
}